<div class="w-full p-10">
	<app-back-to-integrations-button></app-back-to-integrations-button>
	<div
		class="grid gap-10 mt-6 grid-cols-[minmax(100px,_200px)_1fr_minmax(100px,_200px)]"
	>
		<div
			class="flex justify-center items-center h-52 w-52 rounded-lg bg-white border border-gray-200"
		>
			<img
				class="h-16 w-40"
				src="/assets/images/integrations/sign-it/sign-it-powered-by-docu-sign-logo.svg"
				alt="SignIT powered by DocuSign Logo"
			/>
		</div>
		<div class="mb-10">
			<div class="flex items-center gap-3">
				<span class="capitalize h1">SignIT</span>
				<ui-pill></ui-pill>
			</div>
			<p class="text-sm text-gray-500 my-2">
				Your first 3 sends are free — then just {{ integrationCost }} per signed
				package
			</p>
			<p class="text-base">{{ SIGN_IT_DESCRIPTION }}</p>

			<div class="mt-5 inline-block">
				@if (isSignItConnected_()) {
					<app-button
						btn="border"
						size="small"
						(click)="disconnectSignIt()"
						[disabled]="!isLoggedInUserAdmin_()"
						[matTooltip]="tooltips_()"
						matTooltipPosition="above"
						[testHook]="testHooks.DisconnectButton"
					>
						Disconnect
					</app-button>
				} @else {
					<app-button
						btn="primary"
						size="small"
						(click)="openEducationalModal()"
						[testHook]="testHooks.ConnectButton"
					>
						Connect
					</app-button>
				}
			</div>
			<app-profile-benefits
				[shouldDisplayDivider]="false"
				[benefits]="benefits"
			/>
		</div>
		<div class="bg-white border border-gray-200 rounded-lg h-fit">
			<span class="text-xl block w-full border-b border-gray-200 p-4">
				Resources
			</span>

			<div class="p-2">
				<a
					class="flex items-center m-2 text-green-600 cursor-pointer no-border"
					href="https://www.closer.ca/features/e-signing"
					target="_blank"
					rel="noopener noreferrer"
					[testHook]="testHooks.ESigningLink"
				>
					<i-tabler name="info-circle" class="h-3 w-3 mr-1" />
					<span class="text-xs hover:border-b hover:border-green-600">
						Learn More about SignIT
					</span>
				</a>
				@if (isSignItConnected_()) {
					<a
						class="flex items-center m-2 text-green-600 cursor-pointer no-border"
						[routerLink]="businessUrl"
						fragment="E_SIGNING"
						[testHook]="testHooks.BusinessSettingsLink"
					>
						<i-tabler name="settings" class="h-3 w-3 mr-1" />
						<span class="text-xs hover:border-b hover:border-green-600">
							Manage disbursements
						</span>
					</a>
				}
			</div>
		</div>
	</div>
</div>
